import React from 'react';
import './EmptyState.css';

/**
 * EmptyState Component - Displays an empty state message with icon
 *
 * @param {Object} props
 * @param {string} [props.icon="📭"] - Emoji or icon to display
 * @param {string} props.message - Message to display
 * @param {string} [props.className=""] - Additional CSS classes
 */
function EmptyState({ icon = "📭", message, className = "" }) {
  return (
    <div className={`empty-state ${className}`}>
      <span className="empty-icon">{icon}</span>
      <p>{message}</p>
    </div>
  );
}

export default EmptyState;
